<template>
    <v-item-group
        class="flex w-full"
        v-model="selectMembership"
        @change="$emit('input', $event)"
        mandatory
        :class="{ 'px-2': !altPriceAvailable }"
    >
        <v-item
            v-slot="{ active, toggle }"
            :value="{
                id: membership.id,
                price_id: membership.price_id,
            }"
        >
            <v-card
                :class="{
                    'mb-2': !button2,
                    'px-2': !!(active && altPriceAvailable),
                    'px-3': !altPriceAvailable,
                    'py-3': altPriceAvailable,
                }"
                class="soli-round text-center flex-1 justify-center custom-card-round"
                flat
                :outlined="!!(active && altPriceAvailable)"
                @click="toggle"
            >
                <div :class="{ 'd-inline-block': altPriceAvailable }">
                    <div class="flex gap-2">
                        <div
                            class="accent--text font-semibold whitespace-nowrap"
                            :class="{ 'text-xs': !active }"
                        >
                            SAVE {{ membership.discount }}
                        </div>
                        <div
                            class="soli-grey"
                            :class="{ 'text-xs': !active }"
                            style="text-decoration: line-through"
                        >
                            {{ membership.original_amount }}
                        </div>
                    </div>
                    <div class="flex gap-1 align-end soli-grey">
                        <v-icon
                            v-if="!!(active && altPriceAvailable)"
                            color="soli-status-green"
                            >check</v-icon
                        >
                        <div
                            class="font-semibold"
                            :class="[active ? 'text-2xl' : 'text-lg']"
                        >
                            {{ membership.amount }}
                        </div>
                        <div class="text-xs">/month</div>
                    </div>
                    <div
                        class="flex soli-grey whitespace-nowrap"
                        :class="[
                            active ? 'text-sm' : 'text-xs',
                            {
                                'justify-center': altPriceAvailable,
                            },
                        ]"
                    >
                        {{ membership.package }}
                    </div>
                </div>
            </v-card>
        </v-item>
        <v-item
            v-slot="{ active, toggle }"
            v-if="altPriceAvailable"
            :value="{
                id: membership.id,
                price_id: membership.alt_price_id,
            }"
        >
            <v-card
                :class="{
                    'mb-2': !button2,
                    'px-2': active,
                }"
                class="soli-round py-3 text-center flex-1 justify-center custom-card-round"
                flat
                :outlined="active"
                @click="toggle"
            >
                <div class="d-inline-block">
                    <div class="flex gap-2">
                        <div
                            class="accent--text font-semibold whitespace-nowrap text-md"
                            :class="{ 'text-xs': !active }"
                        >
                            SAVE {{ membership.alt_discount }}
                        </div>
                        <div
                            class="soli-grey"
                            :class="{ 'text-xs': !active }"
                            style="text-decoration: line-through"
                        >
                            {{ membership.alt_amount }}
                        </div>
                    </div>
                    <div class="flex gap-1 align-end soli-grey">
                        <v-icon v-if="active" color="soli-status-green"
                            >check</v-icon
                        >
                        <div
                            class="font-semibold"
                            :class="[active ? 'text-2xl' : 'text-lg']"
                        >
                            {{ membership.alt_amount }}
                        </div>
                        <div class="text-xs">/month</div>
                    </div>
                    <div
                        class="soli-grey flex whitespace-nowrap justify-center"
                        :class="[active ? 'text-sm' : 'text-xs']"
                    >
                        {{ membership.alt_package }}
                    </div>
                </div>
            </v-card>
        </v-item>
    </v-item-group>
</template>

<script>
export default {
    props: {
        membership: {
            type: Object,
            default: () => {},
        },
        button2: {
            type: String,
            default: null,
        },
        selected: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            selectMembership: {
                id: this.selected.id,
                price_id: this.selected.price_id,
            },
        };
    },
    computed: {
        altPriceAvailable() {
            return this.membership.alt_price_id;
        },
    },
};
</script>
